import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useDebounce } from 'use-debounce';
import { searchPublicLawyers, PublicLawyer, SearchFilters } from '../../services/lawyerService';
import styles from './DirectoryPage.module.css';
import { FaMapMarkerAlt, FaBalanceScale, FaPhone } from 'react-icons/fa';
import pageStyles from '../Page.module.css';
import Icon from '../../components/common/Icon';

// ضع شعار النقابة في public/logo.png
const LOGO_URL = '/logo-icon.png'; 

const DirectoryPage: React.FC = () => {
  const [lawyers, setLawyers] = useState<PublicLawyer[]>([]);
  const [filters, setFilters] = useState<SearchFilters>({});
  const [isLoading, setIsLoading] = useState(true);
  const [debouncedFilters] = useDebounce(filters, 500); // لتأخير البحث بعد الكتابة

  useEffect(() => {
    const fetchLawyers = async () => {
      setIsLoading(true);
      try {
        const data = await searchPublicLawyers(debouncedFilters);
        setLawyers(data);
      } catch (error) {
        console.error("Failed to fetch lawyers:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchLawyers();
  }, [debouncedFilters]);

  const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value }));
  };

  return (
    <div className={styles.pageWrapper}>
      {/* --- قسم الهيدر --- */}
      <header className={styles.header}>
        <nav className={styles.topNav}>
          <div className={styles.logoContainer}>
            <img src={LOGO_URL} alt="شعار النقابة" className={styles.logo} />
            <span className={styles.logoText}>نقابة المحامين</span>
          </div>
          <div className={styles.authButtons}>
            <Link to="/register" className={styles.authButton}>تسجيل جديد</Link>
            <Link to="/login" className={`${styles.authButton} ${styles.primary}`}>تسجيل الدخول</Link>
          </div>
        </nav>
        <div className={styles.headerContent}>
          <h1>دليل المحامين المعتمدين</h1>
          <p>ابحث بسهولة عن المحامي المناسب لك في جميع أنحاء البلاد</p>
          <nav className={styles.publicNav}>
            <Link to="/services" className={styles.navButton}>
              الخدمات الإلكترونية
            </Link>
            <Link to="/communiques-results" className={styles.navButton}>
              نتائج البلاغات
            </Link>
          </nav>
        </div>
      </header>

      {/* --- قسم المحتوى الرئيسي (البحث والنتائج) --- */}
      <main className={styles.mainContent}>
        <div className={styles.searchFilters}>
          <input
            type="text"
            name="search"
            placeholder="ابحث بالاسم أو رقم القيد..."
            onChange={handleFilterChange}
            className="form-control" // يمكنك استخدام تنسيقات Bootstrap أو MUI هنا إذا أردت
          />
          <input
            type="text"
            name="city"
            placeholder="المدينة..."
            onChange={handleFilterChange}
            className="form-control"
          />
          <input
            type="text"
            name="specialization"
            placeholder="التخصص..."
            onChange={handleFilterChange}
            className="form-control"
          />
        </div>

        <div className={styles.resultsContainer}>
          {isLoading ? (
            <p className={styles.statusMessage}>جاري تحميل قائمة المحامين...</p>
          ) : lawyers.length > 0 ? (
            <div className={styles.resultsGrid}>
              {lawyers.map(lawyer => (
                <div key={lawyer.id} className={styles.lawyerCard}>
                  <div className={styles.cardHeader}>
                    <h3>{lawyer.name}</h3>
                    <span className={styles.cardInfo}>رقم القيد: {lawyer.bar_number}</span>
                  </div>
                  <div className={styles.cardInfo}>
                     <Icon as={FaBalanceScale} style={pageStyles.icon } /><span>{lawyer.specialization}</span>
                  </div>
                  <div className={styles.cardInfo}>
                    <Icon as={FaMapMarkerAlt} style={pageStyles.icon } /> <span>{lawyer.city}</span>
                  </div>
                  <div className={styles.cardContact}>
                    <a href={`tel:${lawyer.phone}`} className={styles.contactButton}>
                      <Icon as={FaPhone} style={pageStyles.icon } /> <span>اتصال</span>
                    </a>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p className={styles.statusMessage}>لا توجد نتائج تطابق بحثك.</p>
          )}
        </div>
      </main>
    </div>
  );
};

export default DirectoryPage;
